import styled from 'styled-components';
import { BodyRegularS, CaptionBoldL, HeadingExtraBoldM } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const FormWrapper = styled.form`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 415px;
`;

export const Container = styled.div`
  position: relative;
  top: '-55px';
`;

export const FormFieldContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ theme }: IThemeProvider) => `
      margin: 0 0 ${theme.layout.spacing.mili} 0;
  `}
`;

export const SurveyDescriptionContainer = styled.div`
  width: 320px;
  height: 100%;
  border-radius: 8px 8px 64px 8px;
  ${({ theme }: IThemeProvider) => `
       background: ${theme.colors.neutral.primary[0]};
       box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    `};
`;

export const SurveyDescriptionImageContainer = styled.div`
  width: 100%;
  height: 128px;
  border-radius: 8px 8px 0 0;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[10]};
  `};
`;

export const SurveyDescriptionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 130px);
  ${({ theme }: IThemeProvider) => `
       padding: ${theme.layout.spacing.decy}
    `};
`;

export const Title = styled(HeadingExtraBoldM)`
  ${({ theme }: IThemeProvider) => `
       margin: 0 0 ${theme.layout.spacing.decy} 0;
    `};
`;

export const Subtitle = styled(CaptionBoldL)`
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
       margin: 0 0 ${theme.layout.spacing.mikro} 0;
       color: ${theme.colors.neutral.primary[80]};
    `};
`;

export const Description = styled(BodyRegularS)`
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ theme }: IThemeProvider) => `
       color: ${theme.colors.neutral.primary[80]};
    `};
`;

export const RadioButtonBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const RadioButtonContainer = styled.div`
  ${({ theme }: IThemeProvider) => `
      margin: ${theme.layout.spacing.nano};
  `}
`;

export const Placeholder = styled.div`
  margin-bottom: 15px;
  border-radius: 5px;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
  `};
`;

export const TitlePlaceholder = styled(Placeholder)`
  width: 200px;
  height: 24px;
`;

export const SubtitlePlaceholder = styled(Placeholder)`
  width: 160px;
  height: 18px;
`;

export const DescriptionPlaceholder = styled(Placeholder)`
  width: 100%;
  height: 60%;
  border-radius: 5px 5px 32px 5px;
`;

export const CheckboxContainer = styled.div`
  gap: 1rem;
  display: flex;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[100]};
      margin: ${theme.layout.spacing.nano};
  `}
`;

export const Label = styled.span`
  text-align: start;
  position: relative;
  font-size: 14px;
  left: 5px;
`;

export const ControllerCont = styled.div`
  position: relative;
`;
